export let lineStyleType = /*#__PURE__*/function (lineStyleType) {
  lineStyleType[lineStyleType["solid"] = 0] = "solid";
  lineStyleType[lineStyleType["dash"] = 1] = "dash";
  return lineStyleType;
}({});
export let LinearDir = /*#__PURE__*/function (LinearDir) {
  LinearDir["VERTICAL"] = "vertical";
  LinearDir["HORIZONTAL"] = "horizontal";
  return LinearDir;
}({});
export let TextureBlend = /*#__PURE__*/function (TextureBlend) {
  TextureBlend["NORMAL"] = "normal";
  TextureBlend["REPLACE"] = "replace";
  return TextureBlend;
}({});
/**
 * 基础图层类型定义
 */

export let SizeUnitType = /*#__PURE__*/function (SizeUnitType) {
  SizeUnitType[SizeUnitType["pixel"] = 0] = "pixel";
  SizeUnitType[SizeUnitType["meter"] = 1] = "meter";
  return SizeUnitType;
}({});

// 栅格瓦片图层

export let CanvasUpdateType = /*#__PURE__*/function (CanvasUpdateType) {
  CanvasUpdateType["ALWAYS"] = "always";
  CanvasUpdateType["DRAGEND"] = "dragend";
  return CanvasUpdateType;
}({});